import React from 'react';
import style from './notFound.module.css';
import notFound from '../../img/tela_de_erro.svg'

const NotFound = () => (
  <div className={style.wrapper}>
    <img src={notFound} alt='background'/>
    
  </div>
  
);

export default NotFound;